import { FormattedCurrency } from '@iwIntlProvider/FormattedCurrency';
import { IconEmailFilled } from '@iwoca/icons';
import { Button } from '@iwoca/orion';

import { useGetFlexiLoanAmount } from './Dashboard.helpers';
import { PartialApplicationState } from './Dashboard.types';
import { useGetSpendingLimits } from './hooks/useGetSpendingLimits';
import MainContentPending from '../../pageStructure/mainContentPending/MainContentPending';

export const PartialView = ({
    application
}: {
    application?: PartialApplicationState;
}) => {
    const { activeSpendingLimit, loadingSpendingLimits } =
        useGetSpendingLimits();
    const { flexiLoanAmount, loadingFlexiLoanAmount } = useGetFlexiLoanAmount();

    const redirect_url = application?.payLink.redirect_url;
    const available_spending_limit = activeSpendingLimit?.available_amount || 0;

    if (loadingSpendingLimits || loadingFlexiLoanAmount)
        return <MainContentPending />;

    if (activeSpendingLimit?.max_amount === 150 && flexiLoanAmount) {
        // We are using max_amount of £150 as a proxy for "the customer has had their offer reduced by outstanding flexi loan(s)"
        return (
            <>
                <div
                    className="flex flex-col gap-xl px-l py-m font-med"
                    data-testid="partial-due-to-flexi"
                >
                    <p className="m-0 text-2xl font-bold max-xs:text-xl">
                        You're{' '}
                        <span className="text-success-drk">approved</span> for a{' '}
                        <FormattedCurrency
                            value={activeSpendingLimit.max_amount}
                        />{' '}
                        spending limit alongside your{' '}
                        <FormattedCurrency value={flexiLoanAmount} /> Flexi-Loan
                    </p>
                    <p className="m-0 text-l max-xs:text-l">
                        We take into account affordability across products when
                        calculating your spending limit.
                        <br />
                        <br />
                        For more information please contact your Account
                        Manager.
                    </p>
                </div>
                <div className="border-b border-structure-80 px-l pb-m pt-m">
                    <Button
                        className="flex max-w-max items-center gap-l"
                        href="mailto:pay@iwoca.co.uk"
                    >
                        <IconEmailFilled /> pay@iwoca.co.uk
                    </Button>
                </div>
                <div className="pt-m text-s font-reg">
                    If you’d like to speak to us about the decision or you have
                    any questions, give us a ring on{' '}
                    <a
                        href="tel:02037780549"
                        className="font-bold text-primary-40 underline"
                    >
                        02037780549
                    </a>
                </div>
            </>
        );
    }

    return (
        <div className="px-l py-m">
            <h2 className="m-0 my-xl text-2xl font-bold max-xs:text-xl">
                You're <span className="text-success-drk">approved</span> for a{' '}
                <FormattedCurrency value={available_spending_limit} /> spending
                limit.
            </h2>
            <p className="m-0 mb-xl text-xl font-med max-xs:text-l">
                To use Pay Later for your order you’ll need to reduce the total
                amount to <FormattedCurrency value={available_spending_limit} />{' '}
                or less.{' '}
            </p>
            {redirect_url && (
                <Button
                    href={redirect_url}
                    variant="primary"
                    size="large"
                    className="mb-xl max-xs:w-full"
                >
                    Go back to your order
                </Button>
            )}
            <p className="m-0 text-m font-reg max-xs:text-s">
                If you’d like to speak to us about the decision or you have any
                questions, give us a ring on{' '}
                <a
                    className="font-med text-primary-40"
                    href="tel:0203 778 0549"
                >
                    0203 778 0549
                </a>
            </p>
        </div>
    );
};
